import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import resumeAnimation from "../assets/formsubmit.json"; // adjust path
import axios from "axios";

const ApplicationForm = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        field: "",
        experience: "",
        message: "",
        resume: null,
    });

    const [messageLength, setMessageLength] = useState(0);
    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "message") {
            setMessageLength(value.length);
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            resume: e.target.files[0],
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const data = new FormData();
            for (const key in formData) {
                data.append(key, formData[key]);
            }

            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/apply`, data);
            setSuccessMsg("✅ Application submitted successfully!");
            setFormData({
                firstName: "",
                lastName: "",
                phone: "",
                email: "",
                field: "",
                experience: "",
                message: "",
                resume: null,
            });
            setMessageLength(0);
        } catch (err) {
            alert("❌ Failed to submit. Try again.");
            console.error(err.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <div className="bg-black xyz text-white min-h-screen py-12 px-6 sm:px-10 lg:px-20">
            <h1 className="font-poppins text-3xl text-center sm:text-4xl md:text-5xl font-bold pb-16 pt-10">
                Application Form
            </h1>

            <div className="flex flex-col lg:flex-row justify-center items-stretch gap-12">
                {/* Left Side Animation */}
                <div className="w-full lg:w-1/2 flex justify-center items-center">
                    <Lottie animationData={resumeAnimation} loop autoplay className="w-90 h-auto" />
                </div>

                {/* Right Side Form */}
                <form onSubmit={handleSubmit} className="w-full lg:w-1/2 space-y-6" encType="multipart/form-data">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {["firstName", "lastName", "phone", "email"].map((field) => (
                            <div key={field}>
                                <label className="block mb-1 text-sm">
                                    {field === "firstName" ? "First Name" :
                                        field === "lastName" ? "Last Name" :
                                            field === "phone" ? "Phone Number" : "Email Address"} *
                                </label>
                                <input
                                    type={field === "email" ? "email" : field === "phone" ? "tel" : "text"}
                                    name={field}
                                    value={formData[field]}
                                    onChange={handleChange}
                                    className="w-full bg-transparent border-b border-gray-400 outline-none py-1"
                                    required
                                />
                            </div>
                        ))}

                        <div>
                            <label className="block mb-1 text-sm">Field *</label>
                            <select
                                name="field"
                                value={formData.field}
                                onChange={handleChange}
                                className="w-full bg-black border-b border-gray-400 outline-none py-1"
                                required
                            >
                                <option value="">Select</option>
                                <option value="WordPress">WordPress</option>
                                <option value="Shopify">Shopify</option>
                                <option value="Full Stack">Full Stack</option>
                                <option value="Graphics">Graphics</option>
                            </select>
                        </div>

                        <div>
                            <label className="block mb-1 text-sm">Experience *</label>
                            <select
                                name="experience"
                                value={formData.experience}
                                onChange={handleChange}
                                className="w-full bg-black border-b border-gray-400 outline-none py-1"
                                required
                            >
                                <option value="">Select</option>
                                {[...Array(11).keys()].map((num) => (
                                    <option key={num} value={num}>{num}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Upload Resume */}
                    <div className="mt-4">
                        <label className="block mb-2 text-sm">Upload Resume</label>
                        <input
                            type="file"
                            name="resume"
                            onChange={handleFileChange}
                            required
                            className="block text-sm text-gray-300 file:bg-teal-600 file:text-white file:px-4 file:py-1 file:rounded file:border-none file:cursor-pointer"
                        />
                    </div>

                    {/* Message Box */}
                    <div>
                        <label className="block mb-2 text-sm">Message</label>
                        <textarea
                            name="message"
                            rows="4"
                            maxLength={180}
                            value={formData.message}
                            onChange={handleChange}
                            className="w-full bg-transparent border border-gray-400 p-2 text-white"
                            placeholder="Enter your message..."
                        ></textarea>
                        <div className="text-sm text-right mt-1 text-gray-400">
                            {messageLength}/180
                        </div>
                    </div>

                    {/* Submit */}
                    <div>
                        <button
                            type="submit"
                            className={`bg-blue-500 hover:bg-blue-600 text-white font-medium px-6 py-2 rounded transition ${loading ? "opacity-50 cursor-not-allowed" : ""
                                }`}
                            disabled={loading}
                        >
                            {loading ? "Submitting..." : "Submit"}
                        </button>
                        {successMsg && <p className="text-green-400 mt-3">{successMsg}</p>}
                    </div>
                </form>
            </div>

            <div className="w-full pt-5 pb-5">
                <hr className="border-t border-white opacity-200" />
            </div>
            
        </div>
    );
};

export default ApplicationForm;
